export default "__VITE_ASSET__h5r0Ce2i__"